<template>
  <div>
    <navbarBox />
    <conferimadddatacomponents />
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import conferimadddatacomponents from "@/components/conferimadddatacomponents.vue";
export default {
  components: { conferimadddatacomponents, navbarBox },
};
</script>
